import { AccordionPanel, Stack } from '@chakra-ui/react';
import { useTranslation } from 'localization';
import { Proposal } from 'types';

import { LDTransactionCard, LDTransactionMessage } from 'components';

import Pending from '../../../Pending';
import WithdrawSettled from '../WithdrawSettled';

type ProposalCardProps = {
  proposal: Proposal;
  refetch: () => void;
  refetchTransaction: () => void;
};

const ProposalCard: React.FC<ProposalCardProps> = ({
  proposal,
  refetch,
  refetchTransaction,
}: ProposalCardProps) => {
  const { t } = useTranslation('component.ldRequests.proposals');

  const STATES: Record<Proposal['status'], React.ReactElement | string> = {
    INIT: (
      <LDTransactionMessage
        title={t('waitForLdRate')}
        status="info"
        textProps={{ color: 'info' }}
      />
    ),
    PENDING: (
      <Pending
        paymentMethods={
          proposal?.destination_wallet?.user?.ld_contract?.payment_methods
        }
        addresses={proposal?.destination_wallet?.user?.ld_contract?.addresses}
        proposalId={proposal?.id || ''}
        refetch={refetch}
      />
    ),
    CANCELED: (
      <LDTransactionMessage
        title={t('canceled')}
        status="error"
        textProps={{ color: 'error' }}
      />
    ),
    APPROVED: (
      <LDTransactionMessage
        title={t('approved')}
        status="info"
        textProps={{ color: 'info' }}
      />
    ),
    REJECTED: (
      <LDTransactionMessage
        title={t('rejected')}
        status="error"
        textProps={{ color: 'error' }}
      />
    ),
    SETTLED: proposal ? (
      <WithdrawSettled
        paymentMethod={proposal.payment_method}
        proposalId={proposal.id}
        refetch={() => {
          refetchTransaction();
          refetch();
        }}
      />
    ) : (
      ''
    ),
    COMPLETED: '',
    FAILED: '',
  };

  return (
    <AccordionPanel pb={4}>
      <LDTransactionCard
        amount={proposal.amount}
        identifier_number={proposal.destination_wallet.user.identifier_number}
        pay_with={proposal.pay_with}
        symbol={proposal?.source_wallet?.currency?.symbol}
        rate={proposal.rate}
        note={proposal.note}
        payment_method={proposal.payment_method}
        receivingValue={proposal.amount * proposal.rate}
        panel="USER"
        method="WITHDRAW"
      />
      <Stack mt="2">{STATES[proposal.status]}</Stack>
    </AccordionPanel>
  );
};
export default ProposalCard;
